let orgService = [
  {
    path: '/orgService/bind_page',
    name: '企业会员绑定',
    component: () => import('@/pages/orgService/bind_page.vue')
  },
  {
    path: '/orgService/service_list',
    name: '企业会员服务列表',
    component: () => import('@/pages/orgService/service_list.vue')
  },
  {
    path: '/orgService/order_list',
    name: '企业会员订单列表',
    component: () => import('@/pages/orgService/order_list.vue')
  },
  {
    path: '/orgService/protocol',
    name: '企业会员服务协议',
    component: () => import('@/pages/orgService/org_service_protocol.vue')
  },
]

export default orgService
